<template>
  <div class="space-y-8">
    <SectionHeader :title="__('About me')">
      <template #icon>
        <Icon class="text-3xl text-primary" name="account_box" is-filled />
      </template>
      <template v-if="canEdit" #button>
        <div class="ml-auto">
          <Button
            class="flex items-center gap-1.5"
            variant="ghost"
            @click="
              isEditing ? handleCancelButtonClick() : handleEditButtonClick()
            "
          >
            <Icon class="text-lg" :name="isEditing ? 'close' : 'edit'" />
            <span>{{ isEditing ? __('Cancel') : __('Edit') }}</span>
          </Button>
        </div>
      </template>
    </SectionHeader>

    <AboutMeEdit
      v-if="isEditing"
      :data="data"
      :options="options"
      :resume="resume"
      :error-message="errorMessage"
      @cancel="handleCancelButtonClick"
      @save="handleSaveButtonClick"
    />
    <AboutMeView
      v-else
      :data="data"
      :availability-data="availabilityData"
      :fields="fields"
      :resume="resume"
      :can-edit="canEdit"
    />
  </div>
</template>

<script setup>
  import {computed, ref} from 'vue';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { SectionHeader } from '@/pages/components/section-header';
  import { AboutMeEdit } from './components/about-me-edit';
  import { AboutMeView } from './components/about-me-view';
  import { __ } from '../../../../../helpers';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    },
    availabilityData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    fields: {
      type: Object,
      required: true
    },
    resume: {
      type: Object,
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  });

  const emits = defineEmits(['update-is-editing', 'update-percentages', 'update-data']);

  const data = ref(JSON.parse(JSON.stringify(props.data)));
  const fields = ref(JSON.parse(JSON.stringify(props.fields)));

  function handleEditButtonClick() {
    emits('update-is-editing', true);
  }

  function handleCancelButtonClick() {
    emits('update-is-editing', false);
  }

  function handleSaveButtonClick(value) {
    data.value = value.data;
    fields.value = value.fields;

    data.value.age = computed(() => {
      const bd = data.value?.birthday
      if (!bd) return null

      const years = new Date(Date.now() - new Date(bd)).getUTCFullYear() - 1970

      return `${years} ${__('years')}`
    })

    emits('update-data', data.value);
    emits('update-is-editing', false);
    emits('update-percentages', {
      sectionPercentage: value.sectionPercentage,
      resumePercentage: value.resumePercentage
    });
  }
</script>
